const rankingItems = [
  { rank: 1, title: '顶流男星深夜密会神秘女子', tag: '新瓜', hot: 98542, change: 'up' },
  { rank: 2, title: '知名网红直播间言论翻车事件', tag: '热议', hot: 87210, change: 'up' },
  { rank: 3, title: '某女团成员私密聊天记录泄露', tag: '实锤', hot: 76335, change: 'up' },
  { rank: 4, title: '综艺节目录制现场争执内幕', tag: '内幕', hot: 65420, change: 'down' },
  { rank: 5, title: '知名导演新片选角潜规则疑云', tag: '深扒', hot: 52187, change: 'new' },
];

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-semibold mb-3">热度排行</span>
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950">今日猛料榜</h2>
          <p className="text-foreground-600 text-sm mt-2">全网吃瓜群众都在关注的热门话题</p>
        </div>

        <div className="space-y-3">
          {rankingItems.map((item, i) => (
            <div key={i} className="flex items-center gap-4 bg-background-50 hover:bg-background-100 rounded-xl p-4 border border-background-200/60 transition-colors cursor-pointer">
              <div className={`w-9 h-9 flex items-center justify-center rounded-lg text-sm font-bold flex-shrink-0 ${
                item.rank === 1 ? 'bg-primary-500 text-background-50' :
                item.rank === 2 ? 'bg-accent-500 text-background-50' :
                item.rank === 3 ? 'bg-secondary-500 text-background-50' :
                'bg-background-200 text-foreground-600'
              }`}>
                {item.rank}
              </div>
              <div className="flex-1 min-w-0">
                <h3 className="text-sm md:text-base font-semibold text-foreground-900 truncate">{item.title}</h3>
              </div>
              <span className={`px-2 py-0.5 rounded text-xs font-medium whitespace-nowrap ${
                item.tag === '新瓜' ? 'bg-primary-100 text-primary-700' :
                item.tag === '实锤' ? 'bg-accent-100 text-accent-700' :
                'bg-secondary-100 text-secondary-700'
              }`}>{item.tag}</span>
              <div className="flex items-center gap-1 text-xs flex-shrink-0">
                {item.change === 'up' && <i className="ri-arrow-up-line text-primary-500"></i>}
                {item.change === 'down' && <i className="ri-arrow-down-line text-secondary-500"></i>}
                {item.change === 'new' && <i className="ri-add-circle-line text-accent-500"></i>}
                <span className="text-foreground-500 font-medium">{item.hot.toLocaleString()}</span>
                <span className="text-foreground-400">热度</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}